
  document.addEventListener("DOMContentLoaded", function () {
    const notifyButtons = document.querySelectorAll(".notify-button");

    notifyButtons.forEach(button => {
      button.addEventListener("click", function () {
        const customerEmail = button.getAttribute("data-customer-email");
        const customerName = button.getAttribute("data-customer-name");

        const productId = button.getAttribute("data-product-id");
        const productTitle = button.getAttribute("data-product-title");
        const productVariantId = button.getAttribute("data-inventory-item-id");
        const imageUrl = button.getAttribute("image-url");
        

        // data-inventory-item-id

        console.log(customerEmail,productVariantId,customerName, productId, productTitle)

        if (customerEmail) {
          fetch("  https://shoemato-email-stock.vercel.app/shopify-notify-me/customer-details", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: customerEmail,name: customerName, product_id: productId, product_title: productTitle, product_variant_id: productVariantId , image_url:imageUrl }),
          })
            .then(response => {

              console.log(response);
              if (response.ok) {
                alert("You will be notified when the product is back in stock!");
              } else {
                alert("Something went wrong. Please try again.");
              }
            })
            .catch(error => console.error("Error:", error));
        } else {
          console.log("Customer email not found");
        }
      });
    });
  });

